import type { DateTime } from "luxon";
import { formatPersonFullName } from "../../utils/formatters";
import type { HospitalData } from "../../utils/models";
import type { Patient } from "./types";

const _mockPatients: Patient[] = [
	{
		patientName: "Harold Jenkins",
		patientId: 83472,
		coverageType: "Long Term",
		medicalConditions: ["advanced MS"],
	},
	{
		patientName: "Martha Lopez",
		patientId: 29513,
		coverageType: "Rehabilitation",
		medicalConditions: ["CHF exacerbation"],
	},
	{
		patientName: "Bernard O’Connell",
		patientId: 74028,
		coverageType: "Rehabilitation",
		medicalConditions: ["Joint Replacement"],
	},
	{
		patientName: "Brenda Raynor",
		patientId: 16294,
		coverageType: "Rehabilitation",
		medicalConditions: ["Hip fracture"],
	},
	{
		patientName: "Clara Davison",
		patientId: 58301,
		coverageType: "Long Term",
		medicalConditions: ["Advanced Alzheimer"],
	},
	{
		patientName: "David Kim",
		patientId: 91735,
		coverageType: "Rehabilitation",
		medicalConditions: ["Stroke (CVA)"],
	},
	{
		patientName: "Eleanor Vance",
		patientId: 40682,
		coverageType: "Long Term",
		medicalConditions: ["Pneumonia"],
	},
	{
		patientName: "Frankie Smith",
		patientId: 12847,
		coverageType: "Rehabilitation",
		medicalConditions: ["Fractured Tibia"],
	},
	{
		patientName: "Georgia Hayes",
		patientId: 57913,
		coverageType: "Long Term",
		medicalConditions: ["Chronic heart failure"],
	},
	{
		patientName: "Ian Nielson",
		patientId: 36420,
		coverageType: "Rehabilitation",
		medicalConditions: ["CHF exacerbation"],
	},
	{
		patientName: "Jacqueline Chen",
		patientId: 90218,
		coverageType: "Long Term",
		medicalConditions: ["Advanced Dementia"],
	},
	{
		patientName: "Kenneth Walker",
		patientId: 47625,
		coverageType: "Rehabilitation",
		medicalConditions: ["Severe pneumonia"],
	},
	{
		patientName: "Laura Baker",
		patientId: 75319,
		coverageType: "Long Term",
		medicalConditions: ["ALS"],
	},
	{
		patientName: "Mark Rourke",
		patientId: 28567,
		coverageType: "Rehabilitation",
		medicalConditions: ["Minor Lacerations"],
	},
	{
		patientName: "Nadia Perez",
		patientId: 61834,
		coverageType: "Long Term",
		medicalConditions: ["Parkinson's Disease"],
	},
	{
		patientName: "Omar Qureshi",
		patientId: 83019,
		coverageType: "Rehabilitation",
		medicalConditions: ["Gout Flare-up"],
	},
	{
		patientName: "Patricia Green",
		patientId: 15973,
		coverageType: "Long Term",
		medicalConditions: ["Chronic Kidney Disease"],
	},
	{
		patientName: "Quentin Harris",
		patientId: 49206,
		coverageType: "Rehabilitation",
		medicalConditions: ["Tonsillitis"],
	},
	{
		patientName: "Rebecca Scott",
		patientId: 78125,
		coverageType: "Long Term",
		medicalConditions: ["Post-operative Care (Hip)"],
	},
	{
		patientName: "Samuel Torres",
		patientId: 4018,
		coverageType: "Rehabilitation",
		medicalConditions: ["Acute Alcohol Withdrawal"],
	},
	{
		patientName: "Teresa Uhlman",
		patientId: 60491,
		coverageType: "Long Term",
		medicalConditions: ["Osteoporosis"],
	},
	{
		patientName: "Victor Wong",
		patientId: 21847,
		coverageType: "Rehabilitation",
		medicalConditions: ["Laryngitis"],
	},
	{
		patientName: "Wendy Young",
		patientId: 96320,
		coverageType: "Long Term",
		medicalConditions: ["Severe Glaucoma"],
	},
	{
		patientName: "Xavier Zola",
		patientId: 54781,
		coverageType: "Rehabilitation",
		medicalConditions: ["Anaphylaxis Recovery"],
	},
	{
		patientName: "Yolanda Adams",
		patientId: 30219,
		coverageType: "Long Term",
		medicalConditions: ["Multiple Sclerosis"],
	},
	{
		patientName: "Zane Brown",
		patientId: 87105,
		coverageType: "Rehabilitation",
		medicalConditions: ["Flu"],
	},
	{
		patientName: "Amy Carter",
		patientId: 49013,
		coverageType: "Long Term",
		medicalConditions: ["Chronic Bronchitis"],
	},
	{
		patientName: "Bill Davison",
		patientId: 13597,
		coverageType: "Rehabilitation",
		medicalConditions: ["Cellulitis"],
	},
	{
		patientName: "Cathy Evans",
		patientId: 78204,
		coverageType: "Long Term",
		medicalConditions: ["Rheumatoid Arthritis"],
	},
	{
		patientName: "Danny Fisher",
		patientId: 60938,
		coverageType: "Rehabilitation",
		medicalConditions: ["Concussion"],
	},
	{
		patientName: "Ella Gomez",
		patientId: 25481,
		coverageType: "Long Term",
		medicalConditions: ["Type 1 Diabetes Complications"],
	},
	{
		patientName: "Felix Hill",
		patientId: 98123,
		coverageType: "Rehabilitation",
		medicalConditions: ["Migraine Management"],
	},
	{
		patientName: "Gina Iyer",
		patientId: 3470,
		coverageType: "Long Term",
		medicalConditions: ["Peripheral Neuropathy"],
	},
	{
		patientName: "Hugh Jackson",
		patientId: 59012,
		coverageType: "Rehabilitation",
		medicalConditions: ["Asthma Attack"],
	},
	{
		patientName: "Ivy Klein",
		patientId: 12098,
		coverageType: "Long Term",
		medicalConditions: ["Cirrhosis"],
	},
	{
		patientName: "Jack Lee",
		patientId: 87310,
		coverageType: "Rehabilitation",
		medicalConditions: ["Broken Finger"],
	},
	{
		patientName: "Kelly Miller",
		patientId: 43129,
		coverageType: "Long Term",
		medicalConditions: ["Hypothyroidism"],
	},
	{
		patientName: "Leo Norris",
		patientId: 65820,
		coverageType: "Rehabilitation",
		medicalConditions: ["Severe Vomiting"],
	},
	{
		patientName: "Mia Owens",
		patientId: 10984,
		coverageType: "Long Term",
		medicalConditions: ["Shingles"],
	},
	{
		patientName: "Noah Platt",
		patientId: 79431,
		coverageType: "Rehabilitation",
		medicalConditions: ["Torn Rotator Cuff"],
	},
	{
		patientName: "Olive Quinn",
		patientId: 38106,
		coverageType: "Long Term",
		medicalConditions: ["Joint Replacement"],
	},
	{
		patientName: "Pete Reynolds",
		patientId: 54602,
		coverageType: "Rehabilitation",
		medicalConditions: ["Hip fracture"],
	},
	{
		patientName: "Quincy Sanchez",
		patientId: 91027,
		coverageType: "Long Term",
		medicalConditions: ["Chronic heart failure"],
	},
	{
		patientName: "Ruth Todd",
		patientId: 27384,
		coverageType: "Rehabilitation",
		medicalConditions: ["CHF exacerbation"],
	},
	{
		patientName: "Scott Upton",
		patientId: 86420,
		coverageType: "Long Term",
		medicalConditions: ["Parkinson"],
	},
	{
		patientName: "Tina Vance",
		patientId: 31597,
		coverageType: "Rehabilitation",
		medicalConditions: ["Hip fracture"],
	},
	{
		patientName: "Uriah White",
		patientId: 50713,
		coverageType: "Long Term",
		medicalConditions: ["Gastrointestinal Bleeding"],
	},
	{
		patientName: "Vivian Xia",
		patientId: 69204,
		coverageType: "Rehabilitation",
		medicalConditions: ["Hip fracture"],
	},
	{
		patientName: "William Yost",
		patientId: 14820,
		coverageType: "Long Term",
		medicalConditions: ["Advanced Dementia"],
	},
	{
		patientName: "Zara Zeller",
		patientId: 98104,
		coverageType: "Rehabilitation",
		medicalConditions: ["Stroke (CVA)"],
	},
	{
		patientName: "Aaron Fox",
		patientId: 32019,
		coverageType: "Long Term",
		medicalConditions: ["Chronic heart failure"],
	},
	{
		patientName: "Bianca Grant",
		patientId: 75018,
		coverageType: "Rehabilitation",
		medicalConditions: ["Knee Replacement"],
	},
	{
		patientName: "Carlos Hayes",
		patientId: 48106,
		coverageType: "Long Term",
		medicalConditions: ["Advanced Alzheimer"],
	},
	{
		patientName: "Diana Irving",
		patientId: 21947,
		coverageType: "Rehabilitation",
		medicalConditions: ["Pneumonia"],
	},
	{
		patientName: "Ethan Johnson",
		patientId: 60482,
		coverageType: "Long Term",
		medicalConditions: ["Parkinson's Disease"],
	},
	{
		patientName: "Fiona Kelly",
		patientId: 13508,
		coverageType: "Rehabilitation",
		medicalConditions: ["CABG recovery"],
	},
	{
		patientName: "George Lewis",
		patientId: 87201,
		coverageType: "Long Term",
		medicalConditions: ["Chronic Heart Disease"],
	},
	{
		patientName: "Hannah Martinez",
		patientId: 49120,
		coverageType: "Rehabilitation",
		medicalConditions: ["Hip replacement"],
	},
	{
		patientName: "Isaac Nelson",
		patientId: 20847,
		coverageType: "Long Term",
		medicalConditions: ["Hip fracture"],
	},
	{
		patientName: "Jasmine Ortiz",
		patientId: 31958,
		coverageType: "Rehabilitation",
		medicalConditions: ["CHF exacerbation"],
	},
	{
		patientName: "Kevin Peterson",
		patientId: 74019,
		coverageType: "Long Term",
		medicalConditions: ["Advanced Dementia"],
	},
];

const hospitalDemoMedicalConditions = ["Hip replacement", "Knee replacement", "Spinal surgery", "Abdominal surgery", "Hernia repair", "Fracture fixation"];

export const getMockPatientsForDate = ({
	hospitalData,
	getDayIndexByDate,
	date,
	getWeekIndexByDate,
	isHospitalDemo,
	lastNameFirst,
}: {
	date: DateTime;
	hospitalData: HospitalData;
	getWeekIndexByDate: (date: DateTime) => number;
	getDayIndexByDate: (date: DateTime) => number;
	isHospitalDemo?: boolean;
	lastNameFirst: boolean;
}) => {
	const dayCensus = Math.max(
		...hospitalData.weeks[getWeekIndexByDate(date)].weeklyShifts
			.flatMap((shifts) => shifts.days[getDayIndexByDate(date)])
			.map((day) => day.census_override?.override_value ?? day.census_high),
	);

	const today = date;

	// Get nurses for hospital demo
	const nurses = isHospitalDemo ? hospitalData.nurses : [];

	const patientsWithAdmissionDate = _mockPatients.map((p) => {
		const daysAgo = p.coverageType === "Rehabilitation" ? p.patientId % 21 : p.patientId % 180;
		const admissionDate = today.minus({ days: daysAgo });
		const chanceInTheFacility = p.coverageType === "Long Term" ? 100 : Math.max(15, 100 - today.diff(admissionDate, "day").days * 2.5);

		const basePatient = {
			...p,
			admissionDate,
			chanceInTheFacility,
		};

		// Add hospital demo fields
		if (isHospitalDemo) {
			const hash = p.patientId;
			const roomNumber = 100 + (hash % 50); // Rooms 100-149
			const nurseYesterdayIndex = hash % nurses.length;
			const nurseTodayIndex = (hash + 1) % nurses.length;
			const scoreMultiplier = 0.7 + (hash % 61) / 100; // Random between 0.7-1.3

			const nurseYesterday = nurses[nurseYesterdayIndex];
			const nurseToday = nurses[nurseTodayIndex];

			// Replace medical conditions with hospital demo conditions
			const medicalConditionIndex = hash % hospitalDemoMedicalConditions.length;
			const medicalConditions = [hospitalDemoMedicalConditions[medicalConditionIndex]];

			return {
				...basePatient,
				medicalConditions,
				room: roomNumber.toString(),
				nurseYesterday: nurseYesterday ? formatPersonFullName(nurseYesterday, lastNameFirst) : "N/A",
				nurseToday: nurseToday ? formatPersonFullName(nurseToday, lastNameFirst) : "N/A",
				patientScore: Number(scoreMultiplier.toFixed(2)),
			};
		}

		return basePatient;
	});

	// return only the amount of patients equal to the dayCensus with random selection
	return {
		census: dayCensus,
		patientsData: patientsWithAdmissionDate.sort(() => 0.5 - Math.random()).slice(0, dayCensus) ?? [],
	};
};
